import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { RefreshCw, CheckCircle, XCircle } from 'lucide-react'
import { exchangeCodeForToken } from '../utils/spotifyAuth'

export default function SpotifyCallback() {
  const navigate = useNavigate()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search)
      const code = params.get('code')
      const errorParam = params.get('error')

      if (errorParam) {
        setStatus('error')
        setError(errorParam === 'access_denied' ? 'Access denied by user' : errorParam)
        return
      }

      if (!code) {
        setStatus('error')
        setError('No authorization code received')
        return
      }

      try {
        await exchangeCodeForToken(code)
        setStatus('success')
        // Redirect back to importer after a short delay
        setTimeout(() => {
          navigate('/importer')
        }, 1500)
      } catch (err) {
        setStatus('error')
        setError(err instanceof Error ? err.message : 'Failed to authenticate')
      }
    }

    handleCallback()
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card text-center max-w-md w-full">
        {status === 'loading' && (
          <>
            <RefreshCw size={48} className="text-primary-400 mx-auto mb-4 animate-spin" />
            <h2 className="text-xl font-semibold mb-2">Connecting to Spotify...</h2>
            <p className="text-dark-400">Please wait while we complete the authentication.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle size={48} className="text-green-400 mx-auto mb-4" />
            <h2 className="text-xl font-semibold mb-2">Connected!</h2>
            <p className="text-dark-400">Redirecting to the importer...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle size={48} className="text-red-400 mx-auto mb-4" />
            <h2 className="text-xl font-semibold mb-2">Connection Failed</h2>
            <p className="text-dark-400 mb-4">{error}</p>
            <button onClick={() => navigate('/importer')} className="btn btn-primary">
              Back to Importer
            </button>
          </>
        )}
      </div>
    </div>
  )
}
